'use client'

import { StytchB2BProvider } from '@stytch/nextjs/b2b'
import { stytchB2bClient } from '../stytch/stytch-b2b-client'

export function StytchB2BClientProvider({
  children
}: {
  children: React.ReactNode
}) {
  return (
    <StytchB2BProvider stytch={stytchB2bClient}>{children}</StytchB2BProvider>
  )
}
